import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import Cube from '../icons/lord/Cube';
import { LordIconSizes, PopupEventNames } from '@/types/client';
import { sendToParent } from '@/lib/popup';
import styles from './PopupFlowCallback.module.scss';
export default function PopupFlowCallback() {
    React.useEffect(function() {
        var searchParams = new URLSearchParams(window.location.search);
        sendToParent(PopupEventNames.RESULT_QUERYSTRING_UPDATE, Object.fromEntries(searchParams.entries()));
        var timeout = setTimeout(function() {
            return self.close();
        }, 1000);
        return function() {
            return clearTimeout(timeout);
        };
    }, []);
    return /*#__PURE__*/ _jsx("div", {
        className: styles.container,
        children: /*#__PURE__*/ _jsx(Cube, {
            trigger: "loop",
            size: LordIconSizes.MEDIUM
        })
    });
}
